import classNames from 'clsx';
import React from 'react';

import styles from './GameCard.scss';

interface GameCardProp {
  className: 'Players' | 'Chip' | 'TimeBank' | 'BuyInReal' | 'BuyInPlay' | 'StartingBlinds';
  label: string;
  value: string | number;
  dataTestId?: string;
}

const GameCard: React.FC<GameCardProp> = ({ className, label, value, dataTestId }) => (
  <div
    className={classNames(styles.gameCard, styles[className as keyof typeof styles])}
    data-testid={dataTestId}
  >
    <i className={classNames(styles.icon, styles[`icon${className}`])} />
    <div className={styles.label}>{label}</div>
    <div className={styles.value}>{value}</div>
  </div>
);

export default GameCard;
